class ProductNotes extends HTMLElement {
  constructor() {
    super();
    this.data = this.parseData();
    this.onVariantUpdate = this.onVariantUpdate.bind(this);
  }

  connectedCallback() {
    document.addEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('venue:variant:updated', this.onVariantUpdate);
  }

  parseData() {
    const el = this.querySelector('[data-notes-map]');
    try {
      return JSON.parse(el?.textContent || '{}');
    } catch (err) {
      return {};
    }
  }

  onVariantUpdate(event) {
    const variant = event.detail?.variant;
    if (!variant) return;

    const profile = this.data.variants?.[variant.id] || this.data.default;
    if (!profile) return;

    Object.keys(profile).forEach((index) => this.renderRow(index, profile[index]));
  }

  renderRow(index, row) {
    const item = this.querySelector(`[data-note-index="${index}"]`);
    if (!item || !row) return;

    const textEl = item.querySelector('.product-notes__text');
    if (textEl && typeof row.text === 'string') textEl.innerHTML = row.text;

    const img = item.querySelector('.product-notes__img');
    if (img && row.icon) {
      img.removeAttribute('srcset');
      img.src = row.icon;
    }
  }
}

if (!customElements.get('product-notes')) {
  customElements.define('product-notes', ProductNotes);
}
